import { Pipe, PipeTransform } from '@angular/core';
import { GraphApi, UserProfile } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { Observable, empty } from 'rxjs';

@Pipe({ name: 'userProfile' })
export class UserProfilePipe implements PipeTransform {
  constructor(private graphApi: GraphApi) {}

  transform(userUUID: string): Observable<UserProfile> {
    if (!userUUID) {
      return empty();
    }
    return this.graphApi.getUser(userUUID);
  }
}
